import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {Button2, Button3} from '../../styles/components/button.style';

export const Wrapper = styled.div`
  font-family: Lato, Helvetica, Arial, sans-serif;
  background-color: ${props => props.theme.basketItem.backgroundColor};
  overflow-y: auto;
  width: ${props => props.theme.basketItem.width.desktop};
  box-shadow: 0 0.3rem 0.9rem rgba(0, 0, 0, 0.5);
  position: relative;
  ${media.medium`
    width: ${props => props.theme.basketItem.width.tablet};
  `};
  ${media.small`
    width: ${props => props.theme.basketItem.width.phone};
    height: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  `};
`;

export const Header = styled.div`
  padding-top: ${props => props.theme.basketModal.padding};
  padding-left: ${props => props.theme.basketModal.padding};
  padding-right: ${props => props.theme.basketModal.padding};
  padding-bottom: ${props => props.theme.padding};
  background-color: ${props => props.theme.primaryColor};
  border-bottom-width: 0.1rem;
  border-bottom-style: solid;
  border-bottom-color: ${props => props.theme.basketModal.borderColor};
`;

export const Content = styled.div`
  padding-right: ${props => props.theme.basketModal.padding};
  padding-left: ${props => props.theme.basketModal.padding};
  padding-bottom: ${props => props.theme.padding};
  padding-top: ${props => props.theme.padding};
  max-height: ${props => props.theme.basketModal.content.maxHeight};
  overflow-y: auto;
  ${media.medium`
    flex-grow: 1;
  `};
  ${media.small`
    max-height: none;
    overflow-y: initial;
  `};
`;

export const Title = styled.span`
  display: block;
  text-align: left;
  text-rendering: optimizelegibility;
  font-size: ${props => props.theme.basketItem.text.fontSize};
  color: ${props => props.theme.secondaryColor};
  font-weight: ${p => p.theme.basketItem.text.fontWeight};
`;

export const Subtitle = styled.span`
  display: block;
  font-size: ${props => props.theme.basketItem.optionsGroup.fontSize};
  line-height: ${props => props.theme.basketItem.optionsGroup.lineHeight};
  text-align: ${p => p.theme.basketItem.subtitle.textAlign};
  color: ${p => p.theme.basketItem.size.color};
  text-transform: ${p => p.theme.basketItem.subtitle.transform};
`;

export const MealDescription = styled.div`
  text-align: left;
  padding-top: ${props => props.theme.padding};
  font-size: ${props => props.theme.basketItem.description.fontSize};
  color: ${props => props.theme.basketItem.description.color};
`;

export const ButtonsHolder = styled.div`
  display: flex;
  background-color: ${props => props.theme.basketModal.footer.backgroundColor};
  padding: ${props => props.theme.upselling.buttons.padding};
  ${media.medium`
    flex-shrink: 0;
  `};
  ${media.small`
    flex-direction: column;
  `};
`;

export const AddToBasket = Button2.extend`
  flex-grow: 1;
  position: relative;
  ${media.small`
    margin: ${props => props.theme.margin} 0 0 0;
  `};
`;

export const QuantityWrapper = styled.div`
  margin-right: ${p => p.theme.margin};
`;

export const PriceTag = styled.span`
  position: absolute;
  right: 0;
  padding-right: ${props => props.theme.padding};
  ${media.small`
    position: relative;
    padding-left: ${props => props.theme.padding};
  `};
`;

export const Cancel = Button3.extend`
  margin-left: ${props => props.theme.margin};
  display: none;
  ${media.small`
    display: block;
    margin: ${props => props.theme.margin} 0 0 0;
  `};
`;

export const Comments = styled.input`
  padding: ${props => props.theme.padding};
  font-size: ${props => props.theme.fontSize};
  letter-spacing: ${props => props.theme.letterSpacing};
  border: none;
  outline: none;
  width: 100%;
  height: ${p => p.theme.basketItem.comment.height};
  background-color: ${p => p.theme.basketItem.comment.backgroundColor};
  &:hover {
    color: ${props => props.theme.secondaryColor};
  }
`;



// WEBPACK FOOTER //
// ./components/Meal/BasketModalItem.style.js